export default class TicketApproController {
	static $inject = [
		'$scope',
		'$timeout',
		'$state',
		'$stateParams',
		'TicketApproService',
		'notification',
		'$location',
		'$anchorScroll',
		'$uibModal',
		'_',
		'ModalService',
		'$translate'
	];

	constructor(
		$scope,
		$timeout,
		$state,
		$stateParams,
		TicketApproService,
		notification,
		$location,
		$anchorScroll,
		$uibModal,
		_,
		ModalService,
		$translate
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.TicketApproService = TicketApproService;
		this.notification = notification;
		this.$location = $location;
		this.$anchorScroll = $anchorScroll;
		this.$uibModal = $uibModal;
		this._ = _;
		this.ModalService = ModalService;
		this.$translate = $translate;
	}

	async $onInit() {
		this.cessions = {};
		this.loading = false;
		this.form = {};

		this.modetracteur = 0;

		this.societe01 = {};
		this.societe01.entity = 'ticket';
		this.societe01.societeComIdSelected = null;
		this.societe01.siteComIdSelected = null;

		this.societe02 = {};
		this.societe02.entity = 'ticket';
		this.societe02.societeComIdSelected = null;
		this.societe02.siteComIdSelected = null;

		this.btnAutorise = false;

		this.optionsList = [
			{ id: 1, value: 'AEO BELLENGREVILLE' },
			{ id: 2, value: 'AEO PLEMET' },
			{ id: 3, value: 'AEO TEST' }
		];

		//this.selectedIdSociete = 55;
		//this.selectedIdSite = 69;

		this.selectedIdSociete = 0;
		this.selectedIdSite = 0;

		this.referenceClient = '';
		this.configReferenceClient = { datatype: '' };

		this.date = 'now';
		this.configDate = { datatype: '' };
		this.configSelectSociete = { datatype: 'societe', readonly: false };

		// Site dépend de société
		this.configSelectSite = {
			datatype: 'site',
			params: [{ societe: { datalink: 'societe' } }],
			readonly: false
		};

		// Tracteur (aucune dépendance externe)
		this.selectedIdTracteur = 0;
		this.configSelectTracteur = {
			datatype: 'tracteur',
			readonly: false
		};

		// Benne dépend du tracteur
		this.selectedIdBenne = 0;
		this.configSelectBenne = {
			datatype: 'benne',
			params: [{ tracteur: { datalink: 'tracteur' } }],
			readonly: false
		};

		// Véhicule dépend du site
		this.selectedIdVehicule = 0;
		this.configSelectVehicule = {
			datatype: 'vehicule',
			params: [{ site: { datalink: 'site' } }],
			readonly: false
		};

		// Transporteur dépend du site
		this.selectedIdTransporteur = 0;
		this.configSelectTransporteur = {
			datatype: 'transporteur',
			params: [{ site: { datalink: 'site' } }],
			readonly: false
		};

		// Chauffeur dépend du transporteur
		this.selectedIdChauffeur = 0;
		this.configSelectChauffeur = {
			datatype: 'chauffeur',
			params: [{ transporteur: { datalink: 'transporteur' } }],
			readonly: false
		};

		// Fournisseur dépend du site
		this.selectedIdFournisseur = 0;
		this.configSelectFournisseur = {
			datatype: 'fournisseur',
			params: [{ site: { datalink: 'site' } }],
			readonly: false
		};

		// Provenance dépend du fournisseur
		this.selectedIdProvenance = 0;
		this.configSelectProvenance = {
			datatype: 'provenance',
			params: [{ fournisseur: { datalink: 'fournisseur' } }],
			readonly: false
		};

		// Produit dépend du site
		this.selectedIdProduit = 0;
		this.configSelectProduit = {
			datatype: 'produit',
			params: [{ site: { datalink: 'site' } }],
			readonly: false
		};

		this.selectedTransportFacture = true;

		this.poidsnet = 0;
		this.configPoidsNet = { masque: 'numeriquePoids' };

		this.configValidate = {
			route: '/massia/tickets/ticket-appro/create',
			icon: 'glyphicon glyphicon-floppy-disk',
			validText: 'VALIDER',
			callbackSuccess: () => this.callbackSuccess()
		};
	}

	handleSelect(selected) {
		console.log('handleSelect : ' + selected);
	}

	annuler() {
		this.$state.go('tickets.list', {}, { reload: true });
	}

	callbackSuccess() {
		this.$state.go('tickets.appro', {}, { reload: true });
	}
}
